export default __webpack_public_path__ + "static/progress-bar-data-viz-dont-4ef5ad28b2c71a4bc6da4e90ecc4ef91.png";